import axios from 'axios';
import config from '../config';
import {handlingSession,sessionID} from './../../utils/handlingSession'
import {userLogs} from './../logs/userLogs'

export const updateAccountInfo = async (formData) => {
    try {
        let url = config.hummBackendAppURL+'user/update-account-info';
        const updateResponse = await axios.post(url, formData, {headers:sessionID('secured')});
        return updateResponse;
    } catch (error) {
        let url = config.hummBackendAppURL+'user/update-account-info';
        await userLogs(url, formData, error);
        if (error.response) {
            handlingSession(error.response.status);
        }
        return error.response;
    }
};